const CLASS_NAME = 'virtual-grid__inner__table__row__cell__'

export function createCellOption () {
  return {
    functional: true,
    render (h, context) {
      const {
        value,
        enableDynamicHeight,
        noWrap,
        rowData,
        rowIndex,
        column,
        columnIndex,
        handleEvent
      } = context.props
      const classes = []
      if (!enableDynamicHeight || noWrap) {
        classes.push(`${CLASS_NAME}label`)
      } else {
        classes.push(`${CLASS_NAME}word_break`)
      }
      const slot = context.slots().default || []
      const labelVnode = () => {
        const handleEventIter = (event, eventType) => {
          const params = { rowData, rowIndex, column, value, eventType, execRow: false, event, columnIndex }
          handleEvent(event, params)
        }
        const cellMouseleave = (event) => {
          handleEventIter(event, 'label-mouse-leave')
        }
        const cellMouseenter = (event) => {
          handleEventIter(event, 'label-mouse-enter')
        }
        return h('div', {
          class: classes,
          on: {
            mouseenter: cellMouseenter,
            mouseleave: cellMouseleave
          },
        }, [...slot, value]) // 需要value判断类型用来解构，否则会污染源数据。
      }
      return labelVnode()
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/body/cell-option.js